module.exports = __webpack_public_path__ + "static/media/empty.4cab99da.svg";